// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2s9Hh","selects":"Documents_selects__1-qvf"};